// material
import {
  Container,
  Button,
  Stack,
  Typography,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Grid
} from '@mui/material';
// hooks
import useSettings from '../../hooks/useSettings';

// components
import Page from '../../components/Page';
import { PATH_DASHBOARD } from '../../routes/paths';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from '../../utils/axios';
import { Fragment, useEffect, useState } from 'react';
import {
  AlarmState,
  AlarmStateChange,
  Device,
  Measure,
  RefactoredDevice
} from '../../@types/model/device';
import dayjs, { Dayjs } from 'dayjs';
import LoadingSpinner from '../../components/LoadingSpinner';
import DeviceDetailsGraph from '../../components/device/DeviceDetails/DeviceDetailsGraph';
import DeviceDetailsInfo from '../../components/device/DeviceDetails/DeviceDetailsInfo';
import DeviceDetailsState from '../../components/device/DeviceDetails/DeviceDetailsState';
import refactorDevices from 'components/device/Components/refactorDevices';

// TIMELINE
import { RootState, useSelector } from '../../redux/store';
import { DeviceType } from '../../@types/model/user';
import { ChartDataPoint, getDevice, putMeasure } from '../../api';
import BasicModal from '../../components/BasicModal';
import * as React from 'react';
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import { MIconButton } from '../../components/@material-extend';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useSnackbar } from 'notistack';
import { DateRange, LoadingButton } from '@mui/lab';
import './../../assets/css/repsol.scss';
import { DEVICETYPES_OCR, checkDeviceTypes } from 'guards/CheckRoles';
import DeviceDetailsStateOCR from 'components/device/DeviceDetails/DeviceDetailsStateOCR';

// ----------------------------------------------------------------------

function DeviceDetailsDashboard(props: any) {
  const Transition = props.TransitionComponent;
  const { guid } = useParams();
  const { themeStretch } = useSettings();

  const { t } = useTranslation();
  const [device, setDevice] = useState<Device | null>(null);
  const [refactoredDevice, setRefactoredDevice] = useState<RefactoredDevice | null>(null);
  const [updatedMeasure, setUpdatedMeasure] = useState<undefined | Measure>(undefined);
  const [updatingMeasure, setUpdatingMeasure] = useState<boolean>(false);
  const [measures, setMeasures] = useState<Measure[]>([]);

  const [chartData, setChartData] = useState<ChartDataPoint[]>([]);
  const [chartDatas, setChartDatas] = useState<ChartDataPoint[][]>([]);
  const [, setAlarmStateChanges] = useState<AlarmStateChange[]>([]);
  const [, setAlarmState] = useState<AlarmState[]>([]);

  const navigate = useNavigate();
  const [, setUpdatingAlarms] = useState(false);

  const { loaded } = useSelector((state: RootState) => state.user);

  const [modalDetailContent, setModalDetailContent] = useState<undefined | ReactJSXElement>();

  const [deviceToDelete, setDeviceToDelete] = useState<undefined | string>();
  const [, setAvailableMetrics] = useState<string[]>([]);

  const [dateRangeValue, setDateRangeValue] = React.useState<DateRange<Dayjs>>([
    dayjs().subtract(3, 'month'),
    dayjs()
  ]);

  const deleteDevice = (deviceGuid: string) => {
    return axios.delete(`/api/v2/device/${deviceGuid}`).then(() => {
      navigate(generatePath(PATH_DASHBOARD.devices.list));
    });
  };

  const loadDeviceData = () => {
    getDevice(
      guid!,
      dateRangeValue[0]!.hour(0).minute(0).second(0),
      dateRangeValue[1]!.hour(23).minute(59).second(59),
      (
        device: Device,
        measures: Measure[],
        chartData: ChartDataPoint[],
        deviceType: DeviceType,
        availableMetrics: string[],
        alarmStateChanges: AlarmStateChange[],
        alarmState: AlarmState[]
      ) => {
        setDevice(device);
        setAlarmStateChanges(alarmStateChanges);
        setAlarmState(alarmState);
        setUpdatingAlarms(false);
        setMeasures(measures);
        setAvailableMetrics(availableMetrics);
        setRefactoredDevice(refactorDevices([device])[0]);
        let chartDataFiltered = chartData
          .filter(
            (item) =>
              (item.name === 'Remain' &&
                device.attributes.device_type !== 'preset:gespasa:diesel-plus-meter') ||
              (item.name === 'Volume' &&
                device.attributes.device_type === 'preset:gespasa:diesel-plus-meter') ||
              item.name === 'Kilos' ||
              (item.name === 'Value' &&
                checkDeviceTypes(device.attributes.device_type, DEVICETYPES_OCR)) //check to add a device type attribute condition
          )
          .map((serie) => {
            if (checkDeviceTypes(device.attributes.device_type, DEVICETYPES_OCR)) {
              let datas = serie.data.map((data, index) => {
                if (index !== 0 && index !== serie.data.length - 1) {
                  return {
                    x: data.x,
                    y: Math.abs(serie.data[index - 1].y - data.y)
                  };
                } else {
                  return {
                    x: data.x,
                    y: 0
                  };
                }
              });
              // We don't want the first and last element because are both 0.
              if (datas && datas.length > 2 && typeof datas !== undefined) {
                datas = datas.slice(1, -1);
              }
              return {
                name: serie.name,
                data: datas
              };
            }
            return serie;
          });

        let extraChartDataFiltered = chartData
          .filter(
            (item) =>
              item.name === 'RemainSmoothed' &&
              device.attributes.device_type !== 'preset:gespasa:diesel-plus-meter'
          )
          .map((serie) => {
            return serie;
          });

        //chartDataFiltered =
        // chartData.map((item) => {
        //   //return item.data.
        //   console.log(item);
        // });
        setChartData(chartDataFiltered);
        setChartDatas([extraChartDataFiltered]);
      }
    );
  };

  useEffect(() => {
    loadDeviceData();
  }, [dateRangeValue, guid]);

  useEffect(() => {}, [chartData, chartDatas]);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /* --------------------- chart ---------------------*/

  if (!device || !loaded) {
    return <LoadingSpinner />;
  }
  const pageTitle =
    device.attributes.name.length > 0 ? device.attributes.name : device.attributes.identifier;

  return (
    <Page title={pageTitle}>
      <DeviceDetailsInfo
        device={device}
        refactoredDevice={refactoredDevice}
        dateRangeValue={dateRangeValue}
      />
      <Grid container spacing={2} className="correctMargins">
        <DeviceDetailsGraph
          device={device}
          dateRangeValue={dateRangeValue}
          chartData={chartData}
          chartDatas={chartDatas}
          refactoredDevice={refactoredDevice}
          setDateRangeValue={setDateRangeValue}
          measures={measures}
        />
        <Grid item xs={12} sm={5} md={4}>
          <div
            className="cuadro-redondeado cuadro-azul"
            style={{ marginBottom: 20, marginRight: 0 }}
          >
            <h3>{t('alarms')}</h3>
            <div className="groups" style={{ marginBottom: 0 }}>
              <div className="group">
                {/* <div className="detail">
                  {t('receive_alert_when')} <span className="rojo">{t('less_than_15')}</span>
                </div> */}
              </div>
            </div>
          </div>
          {refactoredDevice?.attributes.device_type &&
          checkDeviceTypes(refactoredDevice?.attributes.device_type, DEVICETYPES_OCR) ? (
            <DeviceDetailsStateOCR refactoredDevice={refactoredDevice} device={device} />
          ) : (
            <DeviceDetailsState refactoredDevice={refactoredDevice} device={device} />
          )}
        </Grid>
      </Grid>

      <Container maxWidth={themeStretch ? false : 'xl'}>
        <Dialog
          open={deviceToDelete !== undefined}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => {
            setDeviceToDelete(undefined);
          }}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{t('device_delete_confirm')}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {t('device_delete_confirm_dialog')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setDeviceToDelete(undefined);
              }}
            >
              {t('cancel')}
            </Button>
            <Button
              onClick={() => {
                deleteDevice(device.guid);
              }}
            >
              {t('confirm')}
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
      <BasicModal
        open={modalDetailContent !== undefined}
        handleClose={() => {
          setModalDetailContent(undefined);
        }}
      >
        {modalDetailContent ? (
          <Fragment>
            {modalDetailContent}
            <Button
              onClick={() => {
                setModalDetailContent(undefined);
              }}
            >
              {t('close')}
            </Button>
          </Fragment>
        ) : null}
      </BasicModal>
      <BasicModal
        open={updatedMeasure !== undefined}
        handleClose={() => {
          setUpdatedMeasure(undefined);
        }}
      >
        <Stack spacing={3}>
          <Typography variant={'h4'}>{t('update_measure_text')}</Typography>
          {updatedMeasure
            ? updatedMeasure.attributes.data.map(
                (datum: { type: string; value: any; name: string }) => {
                  if (datum) {
                    if (datum.type === 'picture_data') {
                      return (
                        <img
                          key={`${datum.type}_${datum.name}`}
                          onClick={() => {
                            setModalDetailContent(
                              <img
                                src={datum.value}
                                alt={datum.name}
                                style={{ minWidth: '250px' }}
                              />
                            );
                          }}
                          src={datum.value}
                          alt={datum.name}
                          style={{ maxHeight: '80px', maxWidth: '250px', cursor: 'zoom-in' }}
                        />
                      );
                    } else {
                      return (
                        <TextField
                          key={`${datum.type}_${datum.name}`}
                          fullWidth
                          type="number"
                          value={datum.value}
                          label={datum.name}
                          onChange={(event) => {
                            setUpdatedMeasure({
                              guid: updatedMeasure.guid,
                              attributes: {
                                ...updatedMeasure.attributes,
                                data: updatedMeasure.attributes.data.map(
                                  (measureData: { type: string; value: any; name: string }) => {
                                    if (measureData.name === datum.name) {
                                      return {
                                        ...measureData,
                                        value: parseFloat(event.target.value)
                                      };
                                    } else {
                                      return measureData;
                                    }
                                  }
                                )
                              }
                            } as Measure);
                          }}
                        />
                      );
                    }
                  }
                  return null;
                }
              )
            : null}
        </Stack>
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={updatingMeasure}
          sx={{ my: 2 }}
          onClick={() => {
            setUpdatingMeasure(true);
            putMeasure(
              updatedMeasure!,
              () => {
                setUpdatingMeasure(false);
                setUpdatedMeasure(undefined);
                enqueueSnackbar(t('measure_updated'), {
                  variant: 'success',
                  action: (key) => (
                    <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                      <Icon icon={closeFill} />
                    </MIconButton>
                  )
                });
                loadDeviceData();
              },
              () => {
                setUpdatingMeasure(false);
                enqueueSnackbar(t('measure_updated_error'), {
                  variant: 'error',
                  action: (key) => (
                    <MIconButton size="small" onClick={() => closeSnackbar(key)}>
                      <Icon icon={closeFill} />
                    </MIconButton>
                  )
                });
              }
            );
          }}
        >
          {t('edit')}
        </LoadingButton>
      </BasicModal>
    </Page>
  );
}

export default DeviceDetailsDashboard;
